export enum STORAGE_KEY {
  PEFERRED_EXPLORER = 'PEFERRED_EXPLORER',
  RPC_ENDPOINT = 'RPC_ENDPOINT',
  // TRANSACTION_BROADCASTING = 'TRANSACTION_BROADCASTING',
  // FEE_MODE = 'FEE_MODE',
  // FEE = 'FEE',
  TRANSACTION_SETTING = 'TRANSACTION_SETTING',
  INTERVAL = 'INTERVAL',
  TOKEN_MAP = 'TOKEN_MAP',
  USERINFO = 'USERINFO',
  LOGIN_STATUS = 'LOGIN_STATUS',
  TOKEN_INFO = 'TOKEN_INFO',
  SOL_PRICE_USD = 'SOL_PRICE_USD',
  EVENT_NOTIFICATIONS_TIMER = 'EVENT_NOTIFICATIONS_TIMER',
  AIRDROP_DETAIL = 'AIRDROP_DETAIL',
  CLAIM_TIME = 'CLAIM_TIME',
  ERROR_RELOAD_COUNT = 'ERROR_RELOAD_COUNT',
  CONNECT_AT = 'CONNECT_AT',
  TWITTER_AUTH = 'TWITTER_AUTH',
  BEFORE_AUTH_ROUTE = 'BEFORE_AUTH_ROUTE',
  WALLET_NAME = 'walletName',
  OKX_UI_MODAL_STATE = 'OKX_UI_MODAL_STATE',
  TOKEN_SORT_TYPE = 'TOKEN_SORT_TYPE',
  INVITER_CODE = 'INVITER_CODE'
}

export enum AirdropType {
  'PUMPFUN' = 'PUMPFUN',
  'TERMINUS' = 'TERMINUS',
  'INFLUENCE' = 'INFLUENCE',
  'REFERRAL' = 'REFERRAL',
  'SHARE_AIRDROP' = 'SHARE_AIRDROP',
}

export enum BetPointType {
  Terminus = 'Terminus',
  Pumpfun = 'Pumpfun',
  Raydium = 'Raydium',
  Refferal = 'Refferral'
}

export enum AirdropPointPlatform {
  'ALL' = 0,
  'TERMINUS' = 1,
  'PUMPFUN' = 2,
  'RAYDIUM' = 3
}

export const AirdropPointPlatformName = {
  [AirdropPointPlatform.PUMPFUN]: 'Pump.fun',
  [AirdropPointPlatform.TERMINUS]: 'Terminus',
  [AirdropPointPlatform.RAYDIUM]: 'Raydium'
}

export enum AirdropPointTradeType {
  'CREATE_TOKEN' = 0,
  'TOKEN_GRADUATE' = 1,
  'TRADE' = 2
}

export enum LoginStatus {
  LOGOUT = 'LOGOUT', // 未登录
  UNSIGNED = 'UNSIGNED', // 钱包已连接，未签名
  NOTOKEN = 'NOTOKEN', // 钱包已连接，已签名，未获取token
  LOGIN = 'LOGIN' // 登录成功
}

export enum HttpCode {
  MissingParameters = 103,
  AuthenticationFailed = 102,
  TokenExpired = 401,
  SignatureExpired = 104,
  AuthorizationExpires = 201,
  TwitterAuthExpired = 1012,
  TwitterAuthFailed = 1013,
  TwitterUnAuth = 1014,
  TwitterOccupied = 1015,
  Success = 0
}

export enum OrderType {
  ASC = 0,
  DESC = 1
}

export enum Millisecond {
  DAY_1 = 24 * 60 * 60 * 1000,
  MINUTE_1 = 60 * 1000,
  SECOND_1 = 1 * 1000,
  SECOND_3 = 3 * 1000,
  SECOND_5 = 5 * 1000,
  SECOND_8 = 8 * 1000,
  SECOND_10 = 10 * 1000,
  SECOND_30 = 30 * 1000
}

export enum CoinContact {
  Twitter = 'Twitter',
  Telegram = 'Telegram',
  Discord = 'Discord',
  Website = 'Website'
}

export const isProd = window.location.hostname === 'terminus.bet'
